const colors = {
  header: "#eefdf6",
  body: "#fff",
  Primary: "#00B388",
  Secondary: "#eefdf6",
  Light: "#0000008a",
  footer: "#00081f",
};

export default colors;
